import { render, staticRenderFns } from "./MainHeadItem.vue?vue&type=template&id=a4d04494&scoped=true&lang=pug&"
import script from "./MainHeadItem.vue?vue&type=script&lang=js&"
export * from "./MainHeadItem.vue?vue&type=script&lang=js&"
import style0 from "./MainHeadItem.vue?vue&type=style&index=0&id=a4d04494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d04494",
  null
  
)

export default component.exports